import React from 'react'
import './style.css'
import UserMenu from '../user-menu'
import { Row } from '@mattilsynet/mt-ui'
import { Notifications } from '@mattilsynet/mt-common'

const TopMenuElements = () => (
  <Row className="TopMenuElements" align="center">
    <Notifications />
    <UserMenu />
  </Row>
)

export default TopMenuElements
